<div content *ngIf="!showSmileId">
	<section *ngIf="isMobileView && showHeader" class="header w-full">
		<section class="back-arrow flex w-full">
			<a (click)="previousStep()" class="cursor-pointer h-[25px] w-[25px]">
				<img src="assets/images/svgs/chevron-left-blue.svg" />
			</a>
			<p class="text-[14px] font-semibold w-full justify-center flex items-center mr-[25px]">{{headerTitle}}</p>
		</section>
	</section>
	<p *ngIf="showHeader" [class.pt-[18px]]="isMobileView" class="font-semibold mb-1 text-[20px]">Face Verification</p>
	<div class="w-full text-[14px] ">
		Your face needs to be verified against your BVN information.
		Please follow the guidelines below to ensure proper capture.
	</div>
	<div>

		<div class="flex items-center justify-center py-[16px]">
			<img src="/assets/images/start-video.png" class="mx-auto" style="height:14em" />
		</div>
		<div class="rounded-[8px] py-[24px] px-[16px] bg-[#0357EE]/5">
			<div class="text-bold text-black">We recommend that you . . .</div>
			<div class="flex py-[12px]">
				<div class="md:w-1/12 pr-[16px]">
					<img src="assets/images/svgs/onboarding/bulb.svg" class="h-[32px]">
				</div>
				<div class="pr-[8px] flex items-center">
					Stay in a brightly lit environment
				</div>
			</div>

			<div class="flex  py-[12px]">
				<div class="md:w-1/12 pr-[16px]">
					<img src="assets/images/svgs/onboarding/glasses.svg" class="h-[32px]">
				</div>
				<div class="pr-[8px] flex items-center">
					Remove glasses, hats, hijabs, face masks or any other face coverings
				</div>
			</div>
			<div class="flex  py-[12px]" *ngIf="isMetaMapVendor">
				<div class="md:w-1/12 pr-[16px] display-flex">
					<img src="assets/images/svgs/smile.svg" class="h-[32px]">
				</div>
				<div class="flex items-center">
					Remain neutral - don’t smile, keep your mouth closed
				</div>
			</div>
		</div>
	</div>


</div>

<div *ngIf="!showSmileId" class="" [ngClass]="{'bottom-0 left-0 fixed w-full px-[20px] bg-white z-index-100':false}">
	<div class="pt-[32px]" [class.py-[32px]]='!isMobileView && !noBottomPadding'
		*ngIf="metamapData || isLoadingApiReference">
		<div [nzGutter]="24" nz-row nzAlign="middle" class="" nzJustify="space-between">

			<div nz-col nzSpan="24" class="md:text-right w-full flex flex-wrap md:justify-end">

				<div class="  pr-3 flex items-center justify-center "
					[ngClass]="{'w-1/3' : isMobileView,'md:w-auto':!isMobileView}">
					<button (click)="goBack()" *ngIf="metamapData"
						class="px-7 w-full cursor-pointer h-12 text-[#0B3275]/60 flex items-center justify-center">
						Back
					</button>
				</div>
				<div class=" rounded-[8px] h-" [class.md:w-auto]="!isMobileView" [ngClass]="{'w-2/3' : isMobileView }">
					<ng-container *ngIf="isMetaMapVendor else btn">
						<app-custom-meta-map-button *ngIf="!isLoadingApiReference && getFlowId();else loadingButton"
							[metadata]="metamapData" [flowId]="getFlowId()" [useWebSdk]="!isMobileWebViewUser"
							[isCheckingApiMetaMapRef]="isSubmitting" (emitLoadEvent)="getMetaMapApiReference()"
							(emitUserFinishedEvent)="onCompletion()" (emitExitedEvent)="handleIncompleteVerification()"
							[text]="'Begin Video Verification'">
						</app-custom-meta-map-button>
					</ng-container>
					<ng-template #loadingButton>
						<app-kamona-custom-button [isBlock]="true" [isSubmitting]="true"
							[type]="'primary'"></app-kamona-custom-button>
					</ng-template>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="smile-id-container {{isMobileView ? 'is-mobile' : ''}} flex flex-col justify-between"
	*ngIf="showSmileId && !countDownTime">
	<ng-container *ngIf="uploadImageLoader else smileIdTemplate">
		<div [ngClass]="{'min-h-[494px] relative':!isMobileView}">
			<div class="vertically-centralized">
				<app-kamona-loading [parentHeight]="'10'" [loadingText]="loadingText">
				</app-kamona-loading>
			</div>
		</div>
	</ng-container>
	<div *ngIf="!uploadImageLoader" class="pr-3 flex items-center justify-center "
		[ngClass]="{'w-1/3' : isMobileView,'md:w-auto':!isMobileView}">
		<button (click)="cancelLiveLiness()"
			class="px-7 w-full cursor-pointer h-12 text-primary flex items-center justify-center back-btn">
			Back
		</button>
	</div>
</div>

<div class="smile-id-container {{isMobileView ? 'is-mobile' : ''}} display-flex w-full items-center"
	*ngIf="isSubmitting && !isMetaMapVendor && showSmileId">
	<div class="w-full h-full items-center">
		<div *ngIf="countDownTime" style="margin: 0 auto; width: 158px">
			<app-time-line-progress [currentTime]="getCurrentTime()" [isTimerHidden]="canHideTimerCount()"
				[minute]="getRefinedTime(countDownTime?.minutes)" [second]="getRefinedTime(countDownTime?.seconds)"
				[size]="158" [strokeWidth]="8" [totalTime]="TOTAL_TIME_IN_SEC" [type]="ProgressTimelineType.TIMER">
			</app-time-line-progress>
		</div>
		<div class="mt-[17px] flex justify-center">
			<div *ngIf="!canHideTimerCount()" class="text-[18px] text-center leading-[25px] text-black font-bold">
				<div>Verifying your {{loadingLabel}},</div>
				<div>please hold on...</div>
			</div>
			<div *ngIf="canHideTimerCount()" class="text-[18px] text-center leading-[25px] text-black font-bold">
				<div>This may take a while,</div>
				<div>please hold on...</div>
			</div>
		</div>
	</div>
</div>

<ng-template #smileIdTemplate>
	<app-kamona-smile-id (emitImage)="handleEmitImage($event)">
	</app-kamona-smile-id>
</ng-template>

<ng-template #btn>
	<div class="kamona-desktop-button-wrapper">
		<app-kamona-custom-button [isBlock]="true" [isSubmitting]="isSubmitting" (submitForm)="handleNonMetaVendors()" text="Start Verification">
		</app-kamona-custom-button>
	</div>
</ng-template>

<ng-template #faqTemplate>
	<div nz-row nzAlign="middle" class="faq-alert">
		<span class="mr-1">
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z"
					fill="#0361F0" />
			</svg>
		</span>
		<span class="alert-info">
			Having trouble in face verification? Go to
			<a target="_blank" href="{{faqLinks[identityProvider]}}">
				<span class="fw-bold text-primary">
					FAQs
				</span></a>
		</span>
	</div>
</ng-template>
